import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, Volume2Icon, BadgeCheckIcon } from 'lucide-react';
import { HERO, PRICE } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
import { CtaButton } from './CtaButton';
import { StarRating } from './StarRating';
export function HeroSection() {
  return <section className="w-full bg-ink text-white" data-id="element-93">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:py-14" data-id="element-94">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mx-auto mb-8 max-w-4xl text-center font-display text-2xl font-600 leading-tight sm:text-4xl md:text-5xl" data-id="element-95">
          {HERO.eyebrow}
        </motion.p>

        <div className="grid items-center gap-8 lg:grid-cols-2" data-id="element-96">
          {/* Left: video / hero image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="order-1" data-id="element-97">
            <div className="mb-3 flex items-center justify-center gap-2 text-sm font-600 text-gold-light" data-id="element-98">
              <Volume2Icon className="h-4 w-4" aria-hidden="true" data-id="element-99" />
              <span data-id="element-100">{HERO.soundNote}</span>
            </div>
            <div className="group relative aspect-video w-full overflow-hidden rounded-2xl border-4 border-gold shadow-2xl" data-id="element-101">
              <img src="https://images.unsplash.com/photo-1587593810167-a84920ea0781?auto=format&fit=crop&w=1200&q=80" alt="Mostrador de pollería con pollo fresco listo para la venta" className="h-full w-full object-cover" data-id="element-102" />
              <div className="absolute inset-0 flex items-center justify-center bg-ink/40 transition-colors group-hover:bg-ink/30" data-id="element-103">
                <motion.div whileHover={{
                scale: 1.08
              }} className="flex flex-col items-center gap-2" data-id="element-104">
                  <PlayCircleIcon className="h-20 w-20 text-white drop-shadow-lg" aria-hidden="true" data-id="element-105" />
                  <span className="rounded-full bg-crimson px-3 py-1 text-xs font-700 uppercase tracking-wide" data-id="element-106">
                    Reproducir Video
                  </span>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Right: hook + offer */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-2 text-center lg:text-left" data-id="element-107">
            {/* Trust row */}
            <div className="mb-4 flex flex-col items-center gap-2 sm:flex-row sm:justify-center lg:justify-start" data-id="element-108">
              <StarRating size={20} data-id="element-109" />
              <span className="text-sm font-600 text-gray-300" data-id="element-110">
                Cientos de polleros ya usando el sistema
              </span>
            </div>

            <h1 className="mb-5 font-display text-2xl font-600 leading-snug sm:text-3xl" data-id="element-111">
              {HERO.headline}
            </h1>

            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-gold/20 px-3 py-1 text-sm font-700 uppercase tracking-wide text-gold-light" data-id="element-112">
              <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" />
              Compra verificada · Pago único
            </div>

            <div className="mb-5" data-id="element-114">
              <span className="mb-1 block text-sm font-600 uppercase tracking-wide text-gray-400" data-id="element-115">
                {HERO.offerLabel}
              </span>
              <PriceDisplay amount={PRICE.today} className="font-display text-5xl font-700 text-gold-light sm:text-6xl" symbolClassName="mr-0.5 align-top text-3xl" data-id="element-116" />
            </div>

            <CtaButton className="mb-3" data-id="element-117">{HERO.cta}</CtaButton>

            <a href="#oferta" className="mb-3 block text-sm font-600 text-gold-light underline-offset-4 hover:underline" data-id="element-118">
              {HERO.ctaSub}
            </a>

            <p className="text-xs text-gray-400" data-id="element-119">{HERO.singlePayment}</p>
            <p className="mt-1 text-xs text-gray-500" data-id="element-120">{HERO.scarcity}</p>
          </motion.div>
        </div>
      </div>
    </section>;
}